import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'middleEllipsis'
})
export class MiddleEllipsisPipe implements PipeTransform {
  transform(value: string, maxLength: number): string {
    if (!value || value.length <= maxLength) {
      return value;
    }
    const endPartLength = Math.floor((maxLength - 6) / 3); // Shorter end part
    const startPartLength = maxLength - endPartLength - 3; // Longer start part
    const startPart = value.slice(0, startPartLength);
    const endPart = value.slice(-endPartLength);
    return `${startPart}...${endPart}`;
  }
}
